<template>
    <div>
        <transition-group

                name="fade"
                tag="div"
                class="wrap-articles-card"
                v-bind:css="false"
                v-on:before-enter="beforeEnter"
                v-on:enter="enter"
        >
            <a v-for="(article, index) in articles"
               :href="article.url"
               class="article-card"
               :key="index"
               :class="{ big: index === 0 && !homePage }"
               v-if="showArticle(index)"
               :data-index="index"
            >
                <article>
                    <div class="header" :style="'background-image: url('+article.imgUrlSmall+')'">
                        <p>{{article.category}}</p>
                    </div>
                    <div class="body">
                        <div>
                            <h2 class="titre-article" v-html="formatText(article.post_title, 57)"></h2>
                            <p class="extrait" v-html="article.post_excerpt" v-if="index === 0 && !homePage"></p>
                        </div>
                        <span class="lien-inline">Découvrir</span>
                    </div>
                </article>
            </a>
        </transition-group>
        <div class="clearfix cta" v-if="!reachEnd && !homePage">
            <a class="btn chevron dir-down loadmore"
               @click="showMore()"
            >Charger plus d'articles</a>
        </div>
        <div class="clearfix cta" v-if="homePage">
            <a class="btn chevron" :href="magUrl"
            >Tous nos articles</a>
        </div>


    </div>
</template>

<script>
    import $ from 'jquery';
    import {truncate} from 'lodash';
    import {breakpointUp} from '../../libs/Breakpoints';

    export default {
        props: {
            articles: {
                type: Array,
                required: true,
            },
            magUrl: {
                type: String,
                required: false,
            },
        },
        data() {
            return {
                ShowLimit: 5,
                showMoreCount: 8,
                offset: null,
                homePage: false
            };
        },
        computed: {
            reachEnd() {
                if (this.ShowLimit >= this.articles.length) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        methods: {
            showArticle(index) {
                if (index < this.ShowLimit) {
                    return true;
                }
            },
            showMore() {
                // let anchor = 'a[data-index="' + this.offset + '"]'
                setTimeout(() => {
                    this.offset = this.offset + this.showMoreCount;
                    // Scrolling.scrollTo(anchor, 'easeInOutQuint', 1200, 80)

                }, 100);
                this.ShowLimit = this.ShowLimit + this.showMoreCount;
            },
            beforeEnter: function (el) {
                $(el).removeClass('show');
                $(el).addClass('hidden');
            },
            enter: function (el, done) {
                var delay = ((el.dataset.index - this.offset) * 150);
                setTimeout(() => {
                    $(el).addClass('show');
                }, delay);

            },
            formatText(value, length) {
                return breakpointUp('lg') ? truncate(value, {
                    'length': length,
                    'separator': /,? +/
                }) : value;
            }
        },
        mounted() {
            this.offset = this.ShowLimit;
            this.homePage = $('body').hasClass('home');

            $(window).bind('resizeEnd', () => {
                this.$forceUpdate()
            });

        },
    };
</script>



// WEBPACK FOOTER //
// assets/js/components/magazine/ArticleList.vue